<template>
	<div class="column">
		<Header></Header>
		<div class="colunm_main_box">
			<el-breadcrumb
				class="column_top_nav"
				separator-class="el-icon-arrow-right"
				style="font-size:14px;"
			>
				<span style="float:left;">当前位置：</span>
				<el-breadcrumb-item :to="{ path: '/' }"
					>首页</el-breadcrumb-item
				>
				<el-breadcrumb-item
					v-for="(item, index) in location"
					:key="index"
				>
					<span v-if="index != location.length - 1">{{ item }}</span>
					<span v-if="index == location.length - 1" class="active">{{
						item
					}}</span>
				</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="column_center_box">
				<!-- 左侧导航 -->
				<div class="column_l_nav_box">
					<h5 class="column_l_nav_title">{{ topTitle }}</h5>
					<el-menu
						:default-active="currentChoose"
						:unique-opened="true"
						active-text-color="#4EAC41!important"
						class="el-menu-vertical-demo"
						@select="selectMenu"
						style="border-right:none;"
					>
						<div v-for="(item, index) in navData" :key="index">
							<el-submenu
								v-if="item.childrenList.length > 0"
								:index="item.id + ''"
								:title="item.title_name"
								class="column_l_nav_item"
							>
								<template slot="title">
									<span
										:style="
											currentChoose == item.id
												? 'color:rgb(78, 172, 65)'
												: ''
										"
										class="column_l_nav_style1"
										>{{ item.title_name }}</span
									>
								</template>
								<el-menu-item-group>
									<el-menu-item
										v-if="sitem.childrenList.length <= 0"
										v-for="(sitem, i) in item.childrenList"
										:key="i"
										:index="sitem.id + ''"
										:title="sitem.title_name"
										class="column_l_nav_style2"
										>. {{ sitem.title_name }}</el-menu-item
									>

									<el-submenu
										v-if="sitem.childrenList.length > 0"
										v-for="(sitem, i) in item.childrenList"
										:key="i"
										:title="sitem.title_name"
										:index="sitem.id + ''"
										class="column_l_nav_style2"
									>
										<template slot="title"
											><span class="column_l_nav_style1"
												>. {{ sitem.title_name }}</span
											></template
										>
										<el-menu-item
											v-for="(ssitem,
											j) in sitem.childrenList"
											:title="ssitem.title_name"
											:key="j"
											:index="ssitem.id + ''"
											class="column_l_nav_style2"
											>.
											{{
												ssitem.title_name
											}}</el-menu-item
										>
									</el-submenu>
								</el-menu-item-group>
							</el-submenu>
							<el-menu-item
								v-if="item.childrenList.length <= 0"
								:index="item.id + ''"
								:title="item.title_name"
								class="column_l_nav_item"
							>
								<span
									slot="title"
									class="column_l_nav_style1"
									>{{ item.title_name }}</span
								>
							</el-menu-item>
						</div>
						<!-- <el-menu-item index="2" class="column_l_nav_item">
                            <span slot="title" class="column_l_nav_style1">国内政策</span>
                        </el-menu-item>-->
					</el-menu>
					<img
						class="column_l_nav_img"
						src="../../assets/main/navbg.png"
						alt=""
					/>
				</div>
				<!-- 右侧显示部分 -->
				<div class="column_r_box">
					<!-- 默认mode1 showType后台数据1是默认，2是碳排放，3是国际概览 -->
					<Mode1
						v-if="currentModel == '4-4'"
						:currentChoose="currentChoose"
					></Mode1>
					<Mode2
						v-if="currentModel == '4-5'"
						:currentChoose="currentChoose"
					></Mode2>
					<Mode3
						v-if="currentModel == '4-6'"
						:currentChoose="currentChoose"
					></Mode3>
					<Mode4
						v-if="currentModel == '4-7'"
						:currentChoose="currentChoose"
					></Mode4>
					<Mode5
						v-if="currentModel == '4-11'"
						:currentChoose="currentChoose"
					></Mode5>
					<Mode6
						v-if="currentModel == '4-1'"
						:currentChoose="currentChoose"
					></Mode6>
					<Mode7
						v-if="currentModel == '4-9'"
						:currentChoose="currentChoose"
					></Mode7>
					<Mode8
						v-if="currentModel == '4-2'"
						:currentChoose="currentChoose"
					></Mode8>
					<Mode9
						v-if="currentModel == '4-10'"
						:currentChoose="currentChoose"
					></Mode9>
					<Mode10
						v-if="currentModel == '4-12'"
						:currentChoose="currentChoose"
					></Mode10>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';

import Header from '@/components/header';
import Footer from '@/components/footer';
import Mode1 from './mode1.vue'; //绿色债券
import Mode2 from './mode2.vue'; //绿色公募基金
import Mode3 from './mode3.vue'; //绿色私募基金
import Mode4 from './mode4.vue'; //环境责任险
import Mode5 from './mode5.vue'; //绿色信贷(分银行)
import Mode6 from './mode6.vue'; //碳金融产品-碳债券
import Mode7 from './mode7.vue'; //ESG产品-ESG债券
import Mode8 from './mode8.vue'; //碳金融产品-碳基金
import Mode9 from './mode9.vue'; //ESG产品-ESG基金
import Mode10 from './mode10.vue'; //绿色信托

export default {
	props: {},
	components: {
		Header,
		Footer,
		Mode1,
		Mode2,
		Mode3,
		Mode4,
		Mode5,
		Mode6,
		Mode7,
		Mode8,
		Mode9,
		Mode10,
	},
	data() {
		return {
			navData: [], //导航栏数据
			topTitle: '二级栏目', //左侧导航头部标题
			currentChoose: '', //当前选中的栏目uid
			currentModel: '', //当前调用的模板1-0/1-1/1-2:国际概览,2:默认,3:碳排放
			location: [], //获取位置数据
		};
	},
	computed: {},
	created() {
		let _name = magic.getUrlKey('name'); //获取url的参数name
		_name ? (this.topTitle = _name) : (this.topTitle = '二级栏目');

		let _uid = magic.getUrlKey('uid'); //获取url的参数uid
		_uid ? (this.currentChoose = _uid) : '';
	},
	mounted() {
		$('.column_l_nav_item .el-submenu__title').css({
			'font-size': '18px',
			color: '#8C8C8C',
		});

		let _id = magic.getUrlKey('id'); //获取url的参数id
		_id ? this.fetchNavList(_id) : (widnow.location.href = '/index.html');
		this.fetchLoaction(_id);
	},
	methods: {
		//获取导航数据
		fetchLoaction(_id) {
			let _this = this;
			api.getMenu(_id).then((res) => {
				//console.log(res, 'location');
				_this.location = res.data.reverse();
			});
		},
		//点击选择menu栏目
		selectMenu(id) {
			let _this = this;
			for (let i = 0; i < _this.navData.length; i++) {
				//console.log(_this.navData, id, 'res444');
				if (_this.navData[i].id == id) {
					_this.currentModel = _this.navData[i].showType;
					_this.currentChoose = id;
					//console.log(_this.currentModel, 'res111');
				} else {
					if (_this.navData[i].childrenList.length > 0) {
						for (
							let j = 0;
							j < _this.navData[i].childrenList.length;
							j++
						) {
							if (_this.navData[i].childrenList[j].id == id) {
								_this.currentModel =
									_this.navData[i].childrenList[j].showType;
								_this.currentChoose = id;
								//console.log(_this.currentModel, 'res222');
							} else {
								if (
									_this.navData[i].childrenList[j]
										.childrenList.length > 0
								) {
									for (
										let k = 0;
										k <
										_this.navData[i].childrenList[j]
											.childrenList.length;
										k++
									) {
										if (
											_this.navData[i].childrenList[j]
												.childrenList[k].id == id
										) {
											_this.currentModel =
												_this.navData[i].childrenList[
													j
												].childrenList[k].showType;
											_this.currentChoose = id;
											//console.log(
											//_this.currentModel,
											//'res333'
											//);
										}
									}
								}
							}
						}
					}
				}
			}
		},
		//获取导航数据
		fetchNavList(_id) {
			let _this = this;

			api.getNavList(_id).then((res) => {
				_this.navData = res.data;

				if (res.data.length > 0) {
					let _id = magic.getUrlKey('id'); //获取url的参数id

					if (_id) {
						for (let i = 0; i < res.data.length; i++) {
							if (res.data[i].id == _id) {
								if (res.data[i].childrenList.length > 0) {
									if (
										res.data[i].childrenList[0].childrenList
											.length > 0
									) {
										_this.currentChoose =
											res.data[i].childrenList[0]
												.childrenList[0].id + '';
										_this.currentModel =
											res.data[
												i
											].childrenList[0].childrenList[0].showType;
									} else {
										_this.currentChoose =
											res.data[i].childrenList[0].id + '';
										_this.currentModel =
											res.data[
												i
											].childrenList[0].showType;
									}
								} else {
									_this.currentChoose = res.data[i].id + '';
									_this.currentModel = res.data[i].showType;
								}
							}
						}
					}
				}
			});
		},
	},
};
</script>
<style scoped lang="less">
.column {
	width: 100%;
	/* height: 100vh; */
	background: #f2f2f2;
}
.colunm_main_box {
	width: 1300px;
	margin: 0 auto;
	min-height: 600px;
}
.column_top_nav {
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #1a1a1a;
	line-height: 26px;
	height: 54px;
	line-height: 54px;
}
.column_top_nav .active {
	color: #4eac41;
}
.column_center_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 50px;
}
// 左侧导航部分
.column_l_nav_box {
	float: left;
	width: 260px;
	// min-height: 460px;
	padding: 20px;
	background: #fff;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 0px 6px 0px #eeeeee;
	position: relative;
	padding-bottom: 232px;
}
.column_l_nav_title {
	width: 260px;
	height: 50px;
	text-align: center;
	line-height: 50px;
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #f7f7f7;
	background: url('../../assets/main/titlebg.png') no-repeat center;
	background-size: cover;
	margin-bottom: 20px;
}
.column_l_nav_item {
	background: #f2f2f2;
	margin-bottom: 8px;
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #3f433f;
}
.column_l_nav_img {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
}
.column_l_nav_style1 {
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	// color: #3F433F;
}
.column_l_nav_style2 {
	border-bottom: 1px solid #f3f3f3;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #8c8c8c;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.column_l_nav_style3 {
	font-size: 13px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #808080;
}
.column_l_nav_style3:hover {
	color: #4eac41;
}

// 右侧显示部分
.column_r_box {
	float: right;
	width: 950px;
	// padding:14px 30px;
	min-height: 578px;
	// background: #FFFFFF;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 0px 6px 0px #eeeeee;
}
</style>



// WEBPACK FOOTER //
// src/view/lvcolumn/index.vue